import { jsx as _ } from "react/jsx-runtime";
import { T as w, p as D, x as L, d as O, r as R, U } from "../../vendor-CPVnY93G.js";
import { forwardRef as V, useMemo as k, Fragment as q, memo as z } from "react";
import { isAutoColor as E } from "../../theme/color.js";
import { stupidInvertClasses as G } from "../../utils/index.js";
import { I as J } from "../../iconLoader.gen-BMhf6Txz.js";
import { getSpacingClasses as K } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index4.css';const Q = "_xs_gv6b3_1", X = "_sm_gv6b3_5", Y = "_md_gv6b3_9", Z = "_lg_gv6b3_13", oo = "_xl_gv6b3_17", so = "_baseIcon_gv6b3_21", eo = "_moon_gv6b3_58", to = "_red_gv6b3_62", ao = "_sienna_gv6b3_66", no = "_gold_gv6b3_70", co = "_cactus_gv6b3_74", ro = "_green_gv6b3_78", _o = "_teal_gv6b3_82", io = "_blue_gv6b3_86", lo = "_purple_gv6b3_90", mo = "_magenta_gv6b3_94", a = {
  xs: Q,
  sm: X,
  md: Y,
  lg: Z,
  xl: oo,
  baseIcon: so,
  moon: eo,
  red: to,
  sienna: ao,
  gold: no,
  cactus: co,
  green: ro,
  teal: _o,
  blue: io,
  purple: lo,
  magenta: mo
}, bo = V(
  ({
    id: i,
    m: d,
    mt: l,
    mr: m,
    mb: b,
    ml: g,
    p: v,
    pt: p,
    pr: f,
    pb: u,
    pl: $,
    icon: n,
    description: c,
    color: o,
    __inverted: x,
    size: I = "md",
    className: h,
    slot: C,
    ...s
  }, P) => {
    const t = J[n] ?? "", y = k(() => ({ __html: t }), [t]), B = w(i), e = !!c, { focusProps: F, isFocused: M, isFocusVisible: A } = D(s), { hoverProps: H, isHovered: N } = L(s);
    if (!t)
      return null;
    const r = E(o), S = O(
      a.baseIcon,
      a[I],
      r ? a[o] : void 0,
      K({ m: d, mb: b, ml: g, mr: m, mt: l, p: v, pb: u, pl: $, pr: f, pt: p }),
      x ? G() : void 0,
      h
    ), T = e ? { "aria-label": c, role: "img" } : { "aria-hidden": !0, role: "presentation" }, W = e ? {
      "data-focus-visible": A || void 0,
      "data-focused": M || void 0,
      "data-hovered": N || void 0
    } : {}, j = e ? R(s, H, F) : s;
    return /* @__PURE__ */ _(e ? U : q, { children: /* @__PURE__ */ _(
      "span",
      {
        ...j,
        ...T,
        ...W,
        style: o && !r ? { "--icon-color": `var(--${o})` } : void 0,
        slot: C,
        id: B,
        ref: P,
        "data-icon": n,
        className: S,
        dangerouslySetInnerHTML: y
      }
    ) });
  }
), ho = z(bo);
export {
  ho as BaseIcon
};
